var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5387:32781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6815 25.2709C10.8213 25.2709 9.31312 23.7627 9.31312 21.9024C9.31312 20.0422 10.8213 18.534 12.6815 18.534C14.5417 18.534 16.05 20.0422 16.05 21.9024C16.05 23.7627 14.5417 25.2709 12.6815 25.2709ZM12.6815 16.8498C9.89164 16.8498 7.62891 19.1126 7.62891 21.9024C7.62891 24.6923 9.89164 26.9551 12.6815 26.9551C15.4714 26.9551 17.7342 24.6923 17.7342 21.9024C17.7342 19.1126 15.4714 16.8498 12.6815 16.8498Z",
    fill: "#FF2F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39405 12.6586V12.6762C1.5511 12.8598 0.892578 14.272 0.892578 16.0076C0.892578 17.7424 1.5511 19.1546 2.39405 19.339V19.3558L26.5633 26.0691V5.95625L2.39405 12.6586Z",
    fill: "#FF6542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2082 16.0078C31.2082 21.5884 29.3235 26.113 26.9976 26.113C24.6717 26.113 22.7871 21.5884 22.7871 16.0078C22.7871 10.4271 24.6717 5.90251 26.9976 5.90251C29.3235 5.90251 31.2082 10.4271 31.2082 16.0078Z",
    fill: "#BD2300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5387:32781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0507812 0.0078125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcn);
export default __webpack_public_path__ + "static/media/Feedback Icn.86c91bca.svg";
export { ForwardRef as ReactComponent };